var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-list',{attrs:{"list":_vm.list,"columns":_vm.columns,"single-actions":_vm.singleActions,"group-actions":_vm.groupActions,"export-data-options":_vm.exportDataOptions,"expand-config":{ lazy: true, loadMethod: _vm.loadPolicy }}})}
var staticRenderFns = []

export { render, staticRenderFns }